import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../../Seo";
import { SITE_ORIGIN } from "../../../config/site";
import L from "../../../constants/baysportLabels";
import { yandexMetrikaParams } from "../../../analytics/yandexMetrika";
import MarketingShell from "../MarketingShell";
import { listBlogPosts } from "../blog/posts";
import { MARKETING_PATHS } from "../marketingNav";
import s from "../marketing.module.css";

const PATH = MARKETING_PATHS.blog;

function formatDate(iso) {
  try {
    return new Intl.DateTimeFormat("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export default function BlogIndexPage() {
  const posts = listBlogPosts();

  useEffect(() => {
    yandexMetrikaParams({ landing: "blog" });
  }, []);

  return (
    <MarketingShell metrikaLanding="blog">
      <Seo
        title={`Блог ${L.productName} — журнал, абонементы, запуск секции`}
        description={`Статьи для владельцев спортивных секций: электронный журнал, учёт абонементов, приложение клуба и CRM для тренера.`}
        canonicalUrl={`${SITE_ORIGIN}${PATH}`}
        keywords={["блог спортивная crm", "журнал посещаемости", "абонементы секция"]}
      />

      <section className={s.pageHero}>
        <div className={s.pageHeroInner}>
          <p className={s.eyebrow}>Блог</p>
          <h1>Материалы для владельцев секций</h1>
          <p>
            Практика учёта: журнал, абонементы, кабинет родителей и запуск без
            разработчика.
          </p>
        </div>
      </section>

      <section className={s.section}>
        <div className={s.blogList}>
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`${PATH}/${post.slug}`}
              className={s.blogCard}
            >
              <div className={s.blogDate}>{formatDate(post.date)}</div>
              <div>
                <h2>{post.title}</h2>
                <p>{post.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
